var render, staticRenderFns
import script from "./DraggableItem4.vue?vue&type=script&lang=js"
export * from "./DraggableItem4.vue?vue&type=script&lang=js"
import style0 from "./DraggableItem4.vue?vue&type=style&index=0&id=7a99e12e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a99e12e",
  null
  
)

export default component.exports